import PropTypes from 'prop-types';
import React from 'react';
import SpeakerAnimation from '../components/SpeakerAnimation';

const StimulusButton = (props) => (
    <div className={props.styles} aria-label="stimulus button">
        <SpeakerAnimation
            isDisabled={props.isDisabled}
            aria-label="stimulus button"
            isPlaying={props.isPlaying}
            onClick={props.onClick}
        />
    </div>
);

StimulusButton.propTypes = {
    isPlaying: PropTypes.bool,
    isDisabled: PropTypes.bool.isRequired,
    styles: PropTypes.string,
    onClick: PropTypes.func,
};

StimulusButton.defaultProps = {
    isPlaying: false,
    styles: 'stimulus-speaker',
    onClick: () => { },
};

export default StimulusButton;
